var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorBanned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 234,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.405 230H50.199c-4.784 0-8.593-3.87-8.593-8.73V59.73c0-4.86 3.809-8.73 8.593-8.73h218.206c4.784 0 8.594 3.87 8.594 8.73v161.54c0 4.77-3.81 8.73-8.594 8.73z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.405 230H50.199c-4.784 0-8.593-3.87-8.593-8.73V59.73c0-4.86 3.809-8.73 8.593-8.73h218.206c4.784 0 8.594 3.87 8.594 8.73v161.54c0 4.77-3.81 8.73-8.594 8.73z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 72.5h231.251",
    stroke: "#2302F5",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.694 64.95c1.42 0 2.57-1.17 2.57-2.61 0-1.442-1.15-2.61-2.57-2.61-1.419 0-2.569 1.168-2.569 2.61 0 1.44 1.15 2.61 2.57 2.61zM63.136 64.95c1.419 0 2.569-1.17 2.569-2.61 0-1.442-1.15-2.61-2.57-2.61-1.418 0-2.569 1.168-2.569 2.61 0 1.44 1.15 2.61 2.57 2.61zM70.491 64.95c1.419 0 2.57-1.17 2.57-2.61 0-1.442-1.151-2.61-2.57-2.61-1.419 0-2.57 1.168-2.57 2.61 0 1.44 1.151 2.61 2.57 2.61z",
    fill: "#2302F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.396 125.892c4.109-1.74 6.052-6.535 4.339-10.71-1.714-4.175-6.434-6.148-10.544-4.408-4.109 1.741-6.052 6.536-4.339 10.711 1.714 4.174 6.434 6.148 10.544 4.407z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.06 120.21c1.021-.432 1.503-1.623 1.078-2.659a1.991 1.991 0 0 0-2.618-1.095c-1.021.432-1.503 1.623-1.078 2.66a1.99 1.99 0 0 0 2.618 1.094z",
    fill: "#2302F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.88 125.892c4.11-1.74 6.052-6.535 4.339-10.71-1.713-4.175-6.434-6.148-10.543-4.408-4.11 1.741-6.053 6.536-4.339 10.711 1.713 4.174 6.433 6.148 10.543 4.407z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.545 120.21c1.02-.432 1.503-1.623 1.077-2.659a1.99 1.99 0 0 0-2.618-1.095c-1.02.432-1.503 1.623-1.077 2.66a1.99 1.99 0 0 0 2.618 1.094z",
    fill: "#2302F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.589 132.537c.354.09.62.27.974.45 3.987 2.16 5.227 6.209 5.227 6.389.089.45-.088.9-.531.99-.443.09-.886-.09-.975-.54 0 0-1.063-3.599-4.429-5.399-2.57-1.35-5.67-1.44-9.391-.27-.443.18-.886-.09-.975-.54a.722.722 0 0 1 .532-.99c3.543-1.17 6.821-1.17 9.568-.09z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158,
    cy: 205.5,
    rx: 80,
    ry: 7.5,
    fill: "#EBEEFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210.408 107.981H193.14V87.339c0-18.21-14.834-33.044-33.044-33.044-18.209 0-33.043 14.835-33.043 33.044v20.642h-17.268V87.339c.079-27.785 22.605-50.311 50.311-50.311 27.707 0 50.312 22.526 50.312 50.311v20.642z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.096 205.072c-31.396 0-56.905-25.509-56.905-56.983v-34.456a5.879 5.879 0 0 1 5.887-5.887h102.035a5.879 5.879 0 0 1 5.887 5.887v34.456c.078 31.474-25.43 56.983-56.904 56.983z",
    fill: "#fff",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.094 107.746h51.017a5.879 5.879 0 0 1 5.887 5.887v34.456c0 31.474-25.509 56.904-56.904 56.904",
    fill: "#EBEEFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.094 107.746h51.017a5.879 5.879 0 0 1 5.887 5.887v34.456c0 31.474-25.509 56.904-56.904 56.904",
    stroke: "#2302F5",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M172.418 143.38c0-6.75-5.494-12.244-12.244-12.244s-12.244 5.494-12.244 12.244a12.13 12.13 0 0 0 6.357 10.674v14.364a5.879 5.879 0 0 0 5.887 5.886 5.879 5.879 0 0 0 5.887-5.886v-14.364c3.767-2.119 6.357-6.122 6.357-10.674z",
    fill: "#2302F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBanned);
export default __webpack_public_path__ + "static/media/error-banned.f6154330b326658a97cd404ba6d5b629.svg";
export { ForwardRef as ReactComponent };